<template>
  <div id="app">
    <el-container style="display: block;">
      <div class="header">
        <el-header>
          <div class="logo" @click="go('/')">
            <img
              style="width: 180px;height: 80px;"
              src="./assets/img/toplogo.png"
              alt
            />
          </div>
          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :router="router"
          >
            <el-menu-item index="/" class="elmenu">首页</el-menu-item>
            <el-menu-item index="/news" class="elmenu">
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="popperClass"
              >
                <div class="news">
                  <div class="news-tab" @click="go('/news')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/1.png"
                    />中启联信AI一体机
                  </div>
                  <div class="news-tab" @click="go('/xscyq')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/2.png"
                    />信速察舆情
                  </div>
                  <div class="news-tab" @click="go('/xsczj')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/3.png"
                    />信速察智检
                  </div>
                  <div class="news-tab" @click="go('/gxAI')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/4.png"
                    />高校AI助教
                  </div>
                  <div class="news-tab" @click="go('/AIxmt')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/5.png"
                    />AI新媒体运维管理
                  </div>
                  <div class="news-tab" @click="go('/szrsy')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/6.png"
                    />AI数字人手语
                  </div>
                  <div class="news-tab" @click="go('/zhly')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/7.png"
                    />AI低空经济
                  </div>
                </div>
                <div slot="reference" class="elmenu">AI定制化赋能</div>
              </el-popover>
            </el-menu-item>
            <el-menu-item index="/sjbz" class="elmenu">
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="popperClass"
              >
                <div class="news">

                  <!-- //暂时关闭标注基地入口 -->
                  <!-- <div
                    class="news-tab"
                    @click="golink('https://data.zqlinx.com/#/')"
                  >
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/9.png"
                    />中启联信数据中心
                  </div> -->
                  <div
                    class="news-tab"
                    @click="golink('https://minjiangdata.zqlinx.com/#/')"
                  >
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/12.png"
                    />闽江数据标注基地
                  </div>
                </div>
                <div slot="reference" class="elmenu">数据标注服务</div>
              </el-popover>
            </el-menu-item>
            <el-menu-item index="/download" class="elmenu">
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="popperClass"
              >
                <div class="news">
                  <div class="news-tab" @click="go('/download')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/8.png"
                    />数据资产入表服务
                  </div>
                  <!-- <div class="news-tab" @click="go('/sjbz')">数据标注服务</div> -->
                  <div class="news-tab" @click="go('/sjzcyy')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/9.png"
                    />数据资产运营
                  </div>
                  <div class="news-tab" @click="go('/AIdj')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/4.png"
                    />AI党建
                  </div>
                </div>
                <div slot="reference" class="elmenu">政企数据资产</div>
              </el-popover>
            </el-menu-item>
            <el-menu-item index="/product" class="elmenu">
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="popperClass"
              >
                <div class="news">
                  <div class="news-tab" @click="go('/product')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/10.png"
                    />数据监理
                  </div>
                  <div class="news-tab" @click="go('/sjkxjf')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/11.png"
                    />数据可信交付
                  </div>
                </div>
                <div slot="reference" class="elmenu">数据产业赋能</div>
              </el-popover>
            </el-menu-item>
            <el-menu-item index="/case" class="elmenu">
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="popperClass"
              >
                <div class="news">
                  <div class="news-tab" @click="go('/case')">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/10.png"
                    />关于我们
                  </div>
                  <div class="news-tab" @click="goBoss">
                    <img
                      style="width: 20px;margin-right: 20px;"
                      src="./assets/img/icon/11.png"
                    />岗位招聘
                  </div>
                </div>
                <div slot="reference" class="elmenu">关于我们</div>
              </el-popover>
            </el-menu-item>
          </el-menu>
          <div class="header-console-phone">
            <!-- <el-popover placement="bottom" trigger="hover">
            <div class="news" style="width: 220px;">
              <div class="news-tab" style="text-align: left;">服务热线:</div>
              <div class="news-tab" style="color:#7caefb">0591-38205606</div>
              <div class="news-tab" style="color:#7caefb">13328653291</div>
              <div class="news-tab" style="text-align: left;">服务邮箱:</div>
              <div class="news-tab" style="color:#7caefb">market@zqlinx.com</div>
              </div>
            </el-popover> -->
            <img
              slot="reference"
              class="elmenu"
              @click="go('/callMe')"
              src="../src/assets/img/phone.png"
              alt="服务热线"
            />
          </div>
          <el-popover placement="bottom-end" width="320" trigger="hover">
            <div style="display: flex;justify-content: space-between;">
              <div>
              <img width="150px" src="../src/assets/img/qr.jpg" />
              <div style="text-align: center;">微信扫描关注公众号</div>
              </div>
              <div>
              <img width="150px" src="../src/assets/img/swqr.png" />
              <div style="text-align: center;">微信扫码商务咨询</div>
              </div>
            </div>
            <div class="btn1" slot="reference">业务咨询</div>
          </el-popover>
        </el-header>
      </div>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="$route.name != 'home'">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>友情链接</p>
              <span @click="golink('https://www.nda.gov.cn/sjj/index_pc.html')"
                >国家数据局</span
              >
              <span @click="golink('https://www.fjbdex.com/#/home')"
                >福建大数据交易所</span
              >
              <span @click="golink('https://data.zqlinx.com/#/')"
                >中启联信数据中心</span
              >
              <span @click="golink('http://mjaidata.zqlinx.com/#/')"
                >中启联信数据工厂</span
              >
            </li>
            <li>
              <p>产品中心</p>
              <span @click="go('/news')">数据交易一体机</span>
              <span @click="go('/sjzcyy')">公共数据服务平台</span>
              <span @click="go('/sjbz')">AI数据标注服务</span>
            </li>
            <li>
              <p>数据服务</p>
              <span @click="go('/product')">数据资产登记</span>
              <span @click="go('/sjkxjf')">数据治理服务</span>
              <span @click="go('/download')">数据资产入表</span>
            </li>
            <li>
              <p>关于我们</p>
              <span @click="go('/case')">中启联信</span>
              <span @click="go('/sjzcyy')">数据资产增值</span>
              <span @click="go('/case?index=3')">数据服务资讯</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：market@zqlinx.com</span>
              <span>电话：0591-38205606/13328653291</span>
              <span
                >联系地址：福建省福州市鼓楼区软件大道89号福州软件园F区5号楼8层</span
              >
            </li>
          </ul>
          <img src="../src/assets/img/swqr.png" alt />
        </div>
        <div
          style="color: #fff;text-align: center;font-size: 14px;cursor: pointer;"
          @click="goba"
        >
          Copyright © 2026 中启联信科技集团公司版权所有<img
            style="width: 16px;margin: 0 4px -3px 8px;"
            src="../src/assets/img/gh.webp"
          />
          闽ICP备2024080147号-1
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
// import { yiyu } from "https://avatar.gbqr.net/yiyu.js";
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
    };
  },
  mounted() {
    // yiyu.init({
    //   name: 'PvYyeRU5DyvOo2wwNjkWIp5cf2hpDlbItZWDJJlCjXpn0nwS7qKLt5PjZ+/JMnMSsR0VhzQn5WRQWqwfb770yVHhlQtPo9L88sAsJj92dDr4PpeA0Cfu6hXr+oxFZNPinebLwGWR4Hpx6YoRt+5XsKDO3Vj/Sf4LIrW3O/4IbGI=',
    //   readLocalResource: false
    // });
  },
  methods: {
    goBoss() {
      window.open(
        "https://m.zhipin.com/mpa/html/weijd/weijd-boss/79c7d9049b1d45af1nV609i1EFNU?sid=qr_self&openWeapp=1&sbcid=4cf078f3949b8bdc03J43dy0F1A~"
      );
    },
    goba() {
      window.open("https://beian.miit.gov.cn/");
    },
    golink(link) {
      window.open(link);
    },
    go(path) {
      this.$router.push(path);
      this.defaultActive = "";
      setTimeout(() => {
        switch (path) {
          case "/":
            this.defaultActive = "/";
            break;
          case "/news":
            this.defaultActive = "/news";
            break;
          case "/xscyq":
            this.defaultActive = "/news";
            break;
          case "/xsczj":
            this.defaultActive = "/news";
            break;
          case "/gxAI":
            this.defaultActive = "/news";
            break;
          case "/AIxmt":
            this.defaultActive = "/news";
            break;
          case "/szrsy":
            this.defaultActive = "/news";
            break;
          case "/zhly":
            this.defaultActive = "/news";
            break;
          case "/download":
            this.defaultActive = "/download";
            break;
          case "/AIdj":
            this.defaultActive = "/download";
            break;
          case "/sjzcyy":
            this.defaultActive = "/download";
            break;
          case "/product":
            this.defaultActive = "/product";
            break;
          case "/sjkxjf":
            this.defaultActive = "/product";
            break;
        }
      }, 100);
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.news {
  width: 200px;
  font-size: 18px;
  border-radius: 12px;
  padding: 10px;
  background: rgba(255, 255, 255, 0);
  .news-tab {
    display: flex;
    align-items: center;
    // border-bottom: 1px solid #7caefb;
    text-align: left;
    width: 100%;
    // height: 50px;
    line-height: 50px;
    &:hover {
      color: #7caefb;
      cursor: pointer;
    }
  }
  .news-img {
    width: 20px;
    margin-bottom: -5px;
  }
}
.header {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  height: 80px !important;
  width: 100%;
  margin: 0 auto;
  // background: rgba(0,0,0, 0);
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0));
  // backdrop-filter: blur(10px);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0);
}
.el-header {
  height: 80px !important;
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1400px;
  margin: 0 auto;
  // background: rgba(0,0,0, 0.1);
  // backdrop-filter: blur(10px);
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  //background-color: #fff;
  .el-menu-demo {
    background: rgba(0, 0, 0, 0);
    // border-bottom: 1px solid #f3f3f3 !important;
    border-bottom: rgba(0, 0, 0, 0) !important;
    .elmenu {
      font-weight: bold;
      font-size: 18px;
      line-height: 80px;
      height: 80px;
      color: #fff !important;
      &:hover {
        color: #7caefb !important;
        background: rgba(0, 0, 0, 0) !important;
      }
    }
  }
  .header-console {
    display: flex;
    align-items: center;
    .header-console-login {
      margin-right: 20px;
      font-size: 16px;
      color: #fff;
    }
  }

  .header-console-phone {
    cursor: pointer;
    margin-top: 20px;
    padding: 4px;
    height: 34px;
    // background: #f6f7f9;
    font-family: Barlow-Bold;
    border-radius: 17px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    color: #7caefb;
    line-height: 26px;
    margin-right: 18px;
  }

  .btn1 {
    width: 98px;
    height: 48px;
    background: linear-gradient(135deg, #7caefb, #526aff);
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    line-height: 48px;
    text-align: center;
    margin-right: 16px;
    cursor: pointer;
    margin-top: 16px;
  }
  .logo {
    width: 267px;
    cursor: pointer;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 236px;
  overflow: hidden;
  // background-color: #14679f;
  background-image: url(./assets/img/footer.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-size: 14px;
          font-weight: 300;
          padding: 5px 0;
          cursor: pointer;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .el-menu {
  background: rgba(0, 0, 0, 0) !important;
  .el-menu-item.is-active {
    color: #409eff !important;
  }
}
::v-deep .el-menu-item:not(.is-disabled):focus {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
